if (!customElements.get('mx-arrival-tabs')) {
  customElements.define('mx-arrival-tabs', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-arrival-products]');
      this.tabs = [...this.querySelectorAll('[data-arrival-tab]')];
      this.status = this.querySelector('[role="status"]');
      this.viewAll = this.querySelector('.mx-view-all');
      this.allUrl = this.viewAll.href;
      this.cache = new Map();
      this.sequence = 0;
      this.onClick = event => {
        const tab = event.target.closest('[data-arrival-tab]');
        if (!tab || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.selectTab(tab);
      };
      this.onKey = event => {
        const tab = event.target.closest('[data-arrival-tab]');
        if (!tab) return;
        const index = this.tabs.indexOf(tab);
        let target;
        if (event.key === 'ArrowRight') target = this.tabs[(index + 1) % this.tabs.length];
        if (event.key === 'ArrowLeft') target = this.tabs[(index + this.tabs.length - 1) % this.tabs.length];
        if (event.key === 'Home') target = this.tabs[0];
        if (event.key === 'End') target = this.tabs[this.tabs.length - 1];
        if (target) { event.preventDefault(); target.focus(); }
        if (event.key === ' ') { event.preventDefault(); this.selectTab(tab); }
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      const active = this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true');
      if (active) {
        this.grid.setAttribute('aria-labelledby', active.id);
        if (this.dataset.initialSort === (this.dataset.sort || 'created-descending')) {
          this.cache.set(this.tabKey(active), this.grid.innerHTML);
          this.currentTab = active;
        } else {
          this.selectTab(active);
        }
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
    }

    tabKey(tab) {
      const url = new URL(tab.href, location.origin);
      url.searchParams.set('sort_by', this.dataset.sort || 'created-descending');
      url.searchParams.set('section_id', this.dataset.productSection || 'mx-arrival-tab-products');
      return url.toString();
    }

    async selectTab(tab) {
      if (tab === this.currentTab && !this.controller) return;
      const sequence = ++this.sequence;
      this.controller?.abort();
      this.controller = new AbortController();
      this.grid.setAttribute('aria-busy', 'true');
      this.status.classList.add('sr-only');
      this.status.textContent = this.dataset.loading;
      try {
        let html;
        const key = this.tabKey(tab);
        html = this.cache.get(key);
        if (html === undefined) {
            const response = await fetch(key, {signal: this.controller.signal, credentials: 'same-origin'});
            if (!response.ok) throw new Error('Collection could not load');
            const document = new DOMParser().parseFromString(await response.text(), 'text/html');
            const products = document.querySelector('[data-arrival-products]');
            if (!products) throw new Error('Product section missing');
            html = products.innerHTML;
            this.cache.set(key, html);
          }
        if (sequence !== this.sequence || !this.isConnected) return;
        this.grid.querySelectorAll('.mx-card-quick-view[aria-controls]').forEach(button => {
          const modal = document.getElementById(button.getAttribute('aria-controls'));
          if (modal && !this.grid.contains(modal)) modal.remove();
        });
        this.grid.innerHTML = html;
        this.tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        this.grid.setAttribute('aria-labelledby', tab.id);
        this.viewAll.href = tab.dataset.mode === 'mixed' ? this.allUrl : tab.href;
        this.currentTab = tab;
        this.status.textContent = `${tab.textContent.trim()}: ${this.dataset.loaded}`;
      } catch (error) {
        if (error.name !== 'AbortError' && sequence === this.sequence) {
          this.status.classList.remove('sr-only');
          this.status.textContent = this.dataset.error;
        }
      } finally {
        if (sequence === this.sequence) {
          this.controller = null;
          this.grid.setAttribute('aria-busy', 'false');
        }
      }
    }
  });
}
